const hostname = window.location.hostname.toLowerCase();
const localhostApiBase = "http://localhost:5001";
const uatApiBase = "https://altcase-uat-api.altcase.com";
const productionApiBase = "https://altcase-api.altcase.com";

const localhostPartnerPortalBase = "http://localhost:3000";
const uatPartnerPortalBase = "https://uatpartner.altcase.com";
const productionPartnerPortalBase = "https://partners.altcase.com";

/** Dashboard hosts that should use production API. */
const PRODUCTION_DASHBOARD_HOSTS = new Set([
  "managementdashboard.altcase.com",
]);

const UAT_DASHBOARD_HOST = "uatadmin.altcase.com";

export const isLocal =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "[::1]";

/** Pre-DNS prod deploys are served from S3/CloudFront before custom domain cutover. */
const isProdCloudFront = hostname.endsWith(".cloudfront.net");

export const isProd =
  PRODUCTION_DASHBOARD_HOSTS.has(hostname) || isProdCloudFront;

export const isUAT = hostname === UAT_DASHBOARD_HOST;

/** True on the Vite dev server even when opened via LAN IP (e.g. --host). */
const isViteDev = Boolean(import.meta.env?.DEV);

export const PRODUCTION = "PRODUCTION";
export const UAT = "UAT";
export const LOCAL = "LOCAL";

export const environment = isProd
  ? PRODUCTION
  : isUAT
    ? UAT
    : isLocal || isViteDev
      ? LOCAL
      : "Unknown";

export const baseUrl = isProd
  ? productionApiBase
  : isUAT
    ? uatApiBase
    : isLocal || isViteDev
      ? localhostApiBase
      : uatApiBase;

/** Partner portal (IFA) front-end base URL — env-specific, no trailing slash. */
export const partnerPortalBaseUrl = isProd
  ? productionPartnerPortalBase
  : isUAT
    ? uatPartnerPortalBase
    : isLocal || isViteDev
      ? localhostPartnerPortalBase
      : uatPartnerPortalBase;

const uatRaPortalBase = "https://unifiedportal.altcase.com";
const productionRaPortalBase = "https://strike.altcase.com";

/** RA portal base URL — local/UAT share UAT; prod uses production. */
export const momentumBaseUrl = isProd ? productionRaPortalBase : uatRaPortalBase;

/**
 * RM referral login link for partner onboarding.
 * @param {string} internalUserUuid - Logged-in admin user's UUID
 */
export function buildRmReferralLink(internalUserUuid) {
  const code = String(internalUserUuid ?? "").trim();
  if (!code) return "";
  const base = String(partnerPortalBaseUrl).replace(/\/+$/, "");
  return `${base}/onboarding/email?referral_code=${encodeURIComponent(code)}`;
}

/**
 * RA portal referral link for a partner.
 * @param {string} partnerUuid - Partner UUID
 */
export function buildRaReferralLink(partnerUuid) {
  const uuid = String(partnerUuid ?? "").trim();
  if (!uuid) return "";
  const base = String(momentumBaseUrl).replace(/\/+$/, "");
  return `${base}/login?partnerUUID=${encodeURIComponent(uuid)}`;
}

/** Flip to false to test live CMR extraction API on localhost. */
export const MOCK_CMR_EXTRACTION_ENABLED = true;

export const enable_mock_cmr_extraction =
  MOCK_CMR_EXTRACTION_ENABLED && environment === LOCAL;
